import { render } from "./GeneralFailDialog.vue?vue&type=template&id=4cdbfad7"
import script from "./GeneralFailDialog.vue?vue&type=script&lang=js"
export * from "./GeneralFailDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__